module.exports = __webpack_public_path__ + "img/4.cf6acb4f.png";